import * as React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../../redux";
import { isOwner } from "../../../../utilities/is-owner";
import { CreatePostModal } from "./create-post-modal";
import { AddPostButton } from "./add-post-button";
import { PostsGrid } from "./posts-grid";
import { ManagePostsGrid } from "./manage-posts-grid";
import { Person, Entity, GRAPHQL_TYPE_ENTITY } from "@radivision/graphql";
import { PostModal } from "./post-modal";
import "./style.scss";
import { ReorderLink } from "./reorder-link";
import isEmpty from "lodash.isempty";

interface ComponentProps {
  subject: Person | Entity;
}

interface MapDispatchProps {}

interface MapStateProps {
  user: Person | null;
}

export type Props = ComponentProps & MapDispatchProps & MapStateProps;

export const Component = (props: Props) => {
  const { subject, user } = props;
  const owner = isOwner(subject, user);
  const posts = subject?.mediaAbout?.edges?.map((edge: any) => edge.story);
  const hasNoContent = isEmpty(posts);
  const isCompany = subject?.__typename === GRAPHQL_TYPE_ENTITY;

  const userType = user?.accountType?.kind;

  const founderCircles = [
    { id: 1, title: "Create your Personal Profile Page & upload posts & content" },
    { id: 2, title: "Create your Company Profile Page & upload posts & content" },
    { id: 3, title: "Update viewers with Bytes: 'The New IR' to grow engagement" },
    {
      id: 4,
      title: "Pitch Planet: Share your story videos & links for viewers/investors to connect",
    },
  ];

  const investorCircles = [
    { id: 1, title: "Create your Personal Profile Page " },
    { id: 2, title: "Create a Company Profile Page if you wish to" },
    { id: 3, title: "Watch & Read original, curated, & member-content" },
    { id: 4, title: "Click to follow, save, share & connect with startups you like" },
  ];

  const enthusiastCircles = [
    { id: 1, title: "Create your profile page & upload posts & content" },
    { id: 2, title: "Watch & Read the original, curated, & member-content" },
    { id: 3, title: "Click to follow, save, share & connect with startups you like" },
  ];

  const companyCircles = [
    { id: 1, title: "Create your Personal Profile Page " },
    { id: 2, title: "Create a Company Profile Page" },
    { id: 3, title: "Watch & Read original, curated, & member-content" },
    { id: 4, title: "Click to follow, save, share & connect with startups you like" },
    { id: 5, title: "Reach out to Partnerships@Radivision.com to customize unique opportunities together." },
  ];

  let NoContent = null;
  if (subject && owner && hasNoContent) {
    NoContent = (
      <>
        <AddPostButton subject={subject} />
        <h2 className="no-content user-welcome">
          {isCompany ? (
            <>
              <span>
                Welcome Partners! Get ready to embark on an exciting journey into the future of entrepreneurship and
                wealth creation.
                <br /> Radivision's mission is to get more startups funded, so they afford your support to grow their
                success. Meet the startups and consider sponsorships and other opportuities to grow your brand,
                audience, and customer aquisition.
              </span>
              <div className="how-to">How to get started</div>
              <div className="circles-about">
                {companyCircles.map((circle, index) => (
                  <div key={index} className="circle-container">
                    <span className="circle">{circle?.id}</span>
                    <span>{circle?.title}</span>
                  </div>
                ))}
              </div>
            </>
          ) : userType === "ENTHUSIAST" ? (
            <>
              <span>
                Welcome to the Entrerpeneurial Revolution! Get ready to embark on an exciting journey into the future of
                entrepreneurship and wealth creation.
                <br /> Entrepreneurship is not just the biggest trend on the planet, it's the economic paradigm that's
                replaced the Industrial Revolution and where most of the wealth has been created for decades. Meet the
                real-life heroes curing cancer, delivering solutions to many problems, and creating profits for their
                families and investors. Learn how this ecosystem works and how to grow your private equity portfolio,
                and connect to great companies you will discover.
              </span>
              <div className="how-to">How to get started</div>
              <div className="circles-about">
                {enthusiastCircles.map((circle, index) => (
                  <div key={index} className="circle-container">
                    <span className="circle">{circle?.id}</span>
                    <span>{circle?.title}</span>
                  </div>
                ))}
              </div>
            </>
          ) : userType === "INVESTOR" ? (
            <>
              <span>
                Welcome Investors! Get ready to embark on an exciting journey into the future of entrepreneurship and
                wealth creation. <br /> Radivision's mission is to let everyone participate in and prosper in the
                private market of the startup ecosystem, which shifted from public market to private market investing
                over 20 years ago. Radivision aims to provide you with informative and entertaining content, referrals
                to educational and investment partners, and connections to terrific startups that you may discover here.{" "}
              </span>
              <div className="how-to">How to get started</div>
              <div className="circles-about">
                {investorCircles.map((circle, index) => (
                  <div key={index} className="circle-container">
                    <span className="circle">{circle?.id}</span>
                    <span>{circle?.title}</span>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <>
              <span>
                Welcome Founders! Get ready to embark on an exciting journey into the future of entrepreneurship,
                fundraising, and wealth creation. Radivision's mission is to get more startups funded. Leverage the
                platform's investor relations and marketing support to build your brand, grow your audience, and connect
                with AI-driven investor lead-gen, and ecosystem partner. We are reconnecting $72T of US Retail investor
                AUM to private market and IPO investing opportunities for The New Venture Capital."
              </span>
              <div className="how-to">How to get started</div>
              <div className="circles-about">
                {founderCircles.map((circle, index) => (
                  <div key={index} className="circle-container">
                    <span className="circle">{circle?.id}</span>
                    <span>{circle?.title}</span>
                  </div>
                ))}
              </div>
            </>
          )}
        </h2>
      </>
    );
  }

  if (subject && !owner && hasNoContent) {
    NoContent = <h2 className="no-content">There is no posts at the moment. Please check back later.</h2>;
  }

  if (NoContent) {
    return (
      <div className={`tab-pane fade show active`} id="Posts">
        {NoContent}
        {owner ? <CreatePostModal /> : null}
      </div>
    );
  }

  return (
    <div className={`tab-pane fade show active`} id="Posts">
      {owner ? <AddPostButton subject={subject} /> : null}
      {owner ? <ReorderLink subject={subject} /> : null}
      {owner ? (
        <ManagePostsGrid subject={subject} key="posts-grid" />
      ) : (
        <PostsGrid subject={subject} key="posts-grid" />
      )}
      {owner ? <CreatePostModal /> : null}
      <PostModal />
    </div>
  );
};

const mapState = (state: AppState) => ({
  user: state.account.user,
});

const mapDispatch = {};

export const PostsPanel = connect(mapState, mapDispatch)(Component);
